import React from 'react'
import BottomBar from '../../layouts/bottomBar/BottomBar'
import NavbarMobile from '../../layouts/navabrMobile/NavbarMobile'
import Navbar from '../../layouts/navbar/Navbar'
import MobileProfile from '../../mobileView/profile/MobileProfile'

const MobProfile = () => {
  return (
    <div>
        <NavbarMobile />
        <MobileProfile />
        <BottomBar />
    </div>
  )
}

export default MobProfile